export const CHECKOUT_URL = "https://pay.hotmart.com/J108126359X?checkoutMode=10";

export const scrollToId = (id) => {
  const target = `#${id}`;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -112, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const LeafMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#1C3A27" />
    <path
      d="M32 12c10 4 14 12 13 21-1 9-7 16-13 19-6-3-12-10-13-19-1-9 3-17 13-21z"
      fill="#FAF7F2"
    />
    <path
      d="M32 18c0 10 0 20 0 28M32 26c4-2 7-5 8-9M32 34c-4-2-7-5-8-9M32 42c4-2 7-5 8-9"
      stroke="#1C3A27"
      strokeWidth="2.4"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="32" cy="12" r="3" fill="#D4A359" />
  </svg>
);
